class TaskSubTicketPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'task_sub_ticket.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'task_sub_ticket._m';

    // Can access archived sub-tickets
    static ACCESS_ARCHIVE = 'task_sub_ticket.access.archive';

    // Can create new sub-tickets
    static CREATE = 'task_sub_ticket.create';

    // Update sub-ticket scope, expected deliverables and due date
    static UPDATE = 'task_sub_ticket.update';

    // Can assign/reassign sub-ticket designer
    static ASSIGNEE_MANAGE = 'task_sub_ticket.assignee.manage';

    // Can change status of any sub-ticket
    static STATUS_MANAGE = 'task_sub_ticket.status.manage';

    // Can change status only if assigned as a sub-ticket designer
    static STATUS_MANAGE_MOD_ASSIGNED = 'task_sub_ticket.status.manage.mod.assigned';

    // Archive sub-ticket
    static ARCHIVE = 'task_sub_ticket.archive';

    // Restore archived sub-ticket
    static RESTORE = 'task_sub_ticket.restore';
}

export default TaskSubTicketPermission;
